import {createGlobalStyle} from 'styled-components';

const injectFontsStyle = createGlobalStyle`

  @import url('https://use.typekit.net/cut0ggs.css');
  
  body, button, input, select, textarea {
    font-family: 'proxima-nova', sans-serif;
  }

  body {
    font-size:16px;
  }
  
`;

export default injectFontsStyle;
